/** Translation dictionary for the analysis protocol correction module. */
export const analysisProtocolCorrectionTranslations = {
    CS: {
        analysisProtocolCorrection: {
            analysisProtocolCorrectionReportOverview: 'Přehled hlášení opravy rozborového protokolu',
            correctionType: 'Typ opravy',
            technicianNumber: 'Číslo technika',
            earTag: 'Ušní známka',
            stableNumber: 'Číslo stáje',
            proficiencyTestDate: 'Datum KU',
            updatedEarTag: 'Ušní známka ‐ změna',
            milkingDayTime: 'Denní doba',
            milkingInterval: 'Interval',
            milkingCount: 'Počet dojení',
            milkKg: 'Mléko (kg)',
            fatPercentage: 'Tuk (%)',
            proteinPercentage: 'Bílkovina (%)',
            lactosePercentage: 'Laktóza (%)',
            somaticCells: 'SB (tis./ml)',
            urea: 'Močovina (mg/100ml)',
            rewriteApcReportFormData: 'Touto akcí smažete vyplněná data ve formuláři. Opravdu chcete provést tuto akci?',
            noCorrectionReports: 'Nebyla nalezena žádná hlášení oprav rozborových protokolů.',
            correctionTypeDiscard: 'Zrušení',
            correctionTypeUpdate: 'Dohlášení / Změna',
            correctionTypeUpdateEarTag: 'Změna UZ',
            newReport: 'Hlášení',
            deleteDisabledTitle: 'Odebírání záznamů hlášení opravy rozborového je možné provést pouze u záznamů, které ještě nebyly exportovány do COBOLu.',
            editDisabledTitle: 'Editaci záznamů hlášení opravy rozborového je možné provést pouze u záznamů, které ještě nebyly exportovány do COBOLu.',
            deleteCorrectionReport: 'Odstranění hlášení opravy rozborového protokolu',
            reportDeletedSuccessfully: 'Hlášení opravy rozborového protokolu bylo úspěšně odstraněno',
            loadStableDateRelations: 'Načtení stájí a dat KU',
            loadAnalysisProtocol: 'Načtení rozborového protokolu',
            analysisProtocolCorrectionReport: 'Hlášení opravy rozborového protokolu',
            milkingTripleAttribute: 'DD ‐ Interval ‐ Počet dojení',
            milkKgUnit: 'kg',
        },
    },
    EN: {
        analysisProtocolCorrection: {
            analysisProtocolCorrectionReportOverview: 'Analysis protocol correction report overview',
            correctionType: 'Correction type',
            stableNumber: 'Stable number',
            proficiencyTestDate: 'PT Date',
            technicianNumber: 'Technician number',
            earTag: 'Ear tag',
            updatedEarTag: 'Ear tag - change',
            milkingDayTime: 'Day time',
            milkingInterval: 'Interval',
            milkingCount: 'Milking count',
            milkKg: 'Milk (kg)',
            fatPercentage: 'Fat (%)',
            proteinPercentage: 'Protein (%)',
            lactosePercentage: 'Lactose (%)',
            somaticCells: 'SC (1000/ml)',
            urea: 'Urea (mg/100ml)',
            rewriteApcReportFormData: 'This action will delete the entered data in the form. Are you sure you want to perform this action?',
            noCorrectionReports: 'No correction reports found.',
            correctionTypeDiscard: 'Discard',
            correctionTypeUpdate: 'Update',
            correctionTypeUpdateEarTag: 'Ear tag update',
            newReport: 'Report',
            deleteDisabledTitle: 'Removal of correction report records is only possible for records that have not yet been exported to COBOL.',
            editDisabledTitle: 'Editing of correction report records is only possible for records that have not yet been exported to COBOL.',
            deleteCorrectionReport: 'Deleting of correction report',
            reportDeletedSuccessfully: 'Correction report was successfully deleted',
            loadStableDateRelations: 'Load stables and proficiency test dates',
            loadAnalysisProtocol: 'Load analysis protocol',
            analysisProtocolCorrectionReport: 'Analysis protocol correction report',
            milkingTripleAttribute: 'DD - Interval - Milking count',
            milkKgUnit: 'kg',
        },
    },
};
